import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

export const withReloadRoute = Component => props => {
  const key = useSelector(({ routerUi }) => routerUi.get('key'), shallowEqual);

  return <Component {...props} key={key} />;
};
